import { RightOutlined } from "@ant-design/icons"
import { Breadcrumb, BreadcrumbItemProps } from "antd"
import React, { FC } from "react"
import { useJCommonContext } from "../JCommonProvider"
import { getNavPathFromType } from "../lib"
import './JBreadcrumb.scss'


export interface JBreadcrumbItem {
    label: string,
    navigateType?: string
}
export interface JBreadcrumbProps {
    items: JBreadcrumbItem[]
}
export const JBreadcrumb: FC<JBreadcrumbProps> = (props) => {
    const { navigate } = useJCommonContext()
    return (
        <div className="breadcrumb">
            <Breadcrumb separator={<RightOutlined aria-hidden={true} className={'path-separator'} />}>
                {
                    props.items.map((item, i) => {
                        const itemProps: BreadcrumbItemProps = {
                            className: ''
                        }
                        const navigateType = item.navigateType
                        if (navigateType) {
                            itemProps.className += ' pointer'
                            itemProps.onClick = () => navigate(getNavPathFromType(navigateType))
                        }
                        if (i === props.items.length - 1) {
                            itemProps.children += 'last'
                        }
                        return (
                            <Breadcrumb.Item {...itemProps} key={i}>
                                {item.label}
                            </Breadcrumb.Item>
                        )
                    })
                }
            </Breadcrumb>
        </div>
    )
}